const product = r => require.ensure([], () => r(require('@/page/order/product/product')), 'product');
const productDetail = r => require.ensure([], () => r(require('@/page/order/product/productDetail')), 'productDetail');

const notice = r => require.ensure([], () => r(require('@/page/order/notice/notice')), 'notice');
const cart = r => require.ensure([], () => r(require('@/page/order/cart/cart')), 'cart');
const confirm = r => require.ensure([], () => r(require('@/page/order/confirm/confirm')), 'confirm');
const payment=r => require.ensure([], () => r(require('@/page/order/payment/payment')), 'payment');
const payResult=r => require.ensure([], () => r(require('@/page/order/payment/payResult')), 'payResult');
const address=r => require.ensure([], () => r(require('@/page/order/address/address')), 'address');

const wxorders = r => require.ensure([], () => r(require('@/page/order/wxorder/orders')), 'wxorders');

// const wxorders = r => require.ensure([], () => r(require('src/page/vo/wxorder/orders')), 'wxorders')
const wxorderDetail = r => require.ensure([], () => r(require('@/page/order/wxorder/orderDetail')), 'wxorderDetail')
const omsorderDetail = r => require.ensure([], () => r(require('@/page/order/wxorder/omsorderDetail')), 'omsorderDetail')
const mergeOrders = r => require.ensure([], () => r(require('@/page/order/wxorder/mergeOrders')), 'mergeOrders')
const birthday = r => require.ensure([], () => r(require('@/page/show/birthday')), 'birthday')


export default [{
    path: '/home',
    component: product,
    meta: {
        requireAuth: true,
        code: 'WSFT_Product',
        NotLoadData:true
    },
    children: [{
        path: '/order/product/detail',
        component: productDetail,
        meta: {
            requireAuth: true,
            code: 'WSFT_Product',
            NotLoadData:true
        },
    },]
},{
    path: '/order/notice',
    component: notice,
    meta: {
        requireAuth: true,
        code: 'WSFT_Product'
    },
},{
    path: '/order/cart',
    component: cart,
    meta: {
        requireAuth: true,
        code: 'WSFT_Shopcart',
        hideCart:true
    },
},{
    path: '/order/confirm',
    component: confirm,
    meta: {
        requireAuth: true,
        code: 'WSFT_Orders',
        hideCart:true
    },
},{
    path: '/order/payment',
    component: payment,
    meta: {
        requireAuth: true,
        code: 'WSFT_Orders',
        hideCart:true
    },
},{
    path: '/order/payresult',
    component: payResult,
    meta: {
        // requireAuth: true,
        code: 'WSFT_Orders'
    },
},{
    path: '/order/address',
    component: address,
    meta: {
        requireAuth: true,
        code: 'WSFT_Orders'
    },
},{
    path: '/order/orders',
    component: wxorders,
    meta: {
        requireAuth: true,
        code: 'WSFT_Orders'
    },
    children:[{
        path: '/order/detail',
        component: wxorderDetail,
        meta: {
            requireAuth: true,
            code: 'WSFT_Orders'
        }
    },{
        path: '/order/omsdetail',
        component: omsorderDetail,
        meta: {
            requireAuth: true,
            code: 'WSFT_Orders'
        }
    },
    ]
},{
    path: '/order/mergeorders',
    component: mergeOrders,
    meta: {
        requireAuth: true,
        code: 'WSFT_Orders'
    },
},
{
    path: '/show/birthday',
    component: birthday,
    meta: {
        requireAuth: false,
    },
}]


